<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    align?: 'left' | 'center' | 'right';
    attached?: boolean;
  }>(),
  { align: 'left' },
);

const justify = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};
</script>

<template>
  <div
    class="flex flex-wrap"
    :class="{
      [justify[props.align]]: true,
      'group/v-button-group--attached': props.attached,
      'items-center gap-2': !props.attached,
    }"
  >
    <slot></slot>
  </div>
</template>
